import {createFileRoute} from '@tanstack/react-router';

import ClubInviteAcceptView from '../clubs/ClubInviteAcceptView.tsx';

export const Route = createFileRoute('/club-invite/$token')({
    component: RouteComponent,
});

function RouteComponent() {
    return <ClubInviteAcceptView />;
}
